import { Card } from "../../ui/card";

const HorizontalCardSkeleton = () => {
  return (
    <Card className="relative overflow-hidden rounded-md border border-gray-100 bg-white shadow-md">
      <div className="flex p-3">
        <div className="skeleton-block h-24 w-24 flex-shrink-0 rounded" />

        <div className="ml-4 flex flex-1 flex-col justify-between space-y-2">
          <div className="skeleton-block h-5 w-3/4 rounded" />
          <div className="skeleton-block h-4 w-full rounded" />
          <div className="skeleton-block h-4 w-2/3 rounded" />
        </div>
      </div>

      <div className="flex items-center justify-between border-t border-gray-300 p-2">
        <div className="flex items-center space-x-4">
          <div className="skeleton-block h-4 w-20 rounded" />
          <div className="skeleton-block h-4 w-20 rounded" />
        </div>
        <div className="skeleton-block h-10 w-28 rounded" />
      </div>
    </Card>
  );
};

export default HorizontalCardSkeleton;